'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import { ScanLine, X, AlertTriangle, CheckCircle } from 'lucide-react';
import { toast } from 'sonner';

export default function ScanAlertCard() {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className="my-4 bg-amber-50 border border-amber-200 rounded-2xl p-4 flex items-start gap-4 animate-fade-in-up">
      <div className="w-10 h-10 bg-amber-100 rounded-xl flex items-center justify-center flex-shrink-0">
        <ScanLine size={18} className="text-amber-600" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-0.5">
          <AlertTriangle size={13} className="text-amber-600" />
          <p className="text-xs font-700 uppercase tracking-wide text-amber-700">Scan Alert</p>
          <span className="text-xs text-amber-600/70">Today at 18:42</span>
        </div>
        <p className="text-sm font-600 text-foreground">
          Your <span className="text-accent">North Face Jacket</span> was scanned.
        </p>
        <p className="text-xs text-muted-foreground mt-0.5">
          Someone scanned the RETURNI label. Do you still have this item?
        </p>
        <div className="flex items-center gap-2 mt-3">
          <button
            onClick={() => {
              setDismissed(true);
              toast?.success("Good — item marked safe.");
            }}
            className="flex items-center gap-1.5 bg-accent text-white text-xs font-600 px-3 py-1.5 rounded-full hover:bg-accent/90 transition-colors"
          >
            <CheckCircle size={12} />
            Yes — Everything&apos;s Fine
          </button>
          <Link
            href="/lost-mode"
            className="flex items-center gap-1.5 bg-red-500 text-white text-xs font-600 px-3 py-1.5 rounded-full hover:bg-red-600 transition-colors"
          >
            No — Report Lost
          </Link>
        </div>
      </div>
      <button
        onClick={() => setDismissed(true)}
        className="text-muted-foreground hover:text-foreground transition-colors flex-shrink-0"
        aria-label="Dismiss alert"
      >
        <X size={16} />
      </button>
    </div>
  );
}